 import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/shared/configuration';
import { DataStoreService } from '../../../services/data-store.service';
import { FnolModelService } from '../../../services/fnol-model.service';
import moment from 'moment';
import { cdpLite } from './cdp-lite-model'
import { URL_PARAMETERS } from '../../../config/urlParameters.constant';
import { CHECKBOXHEADINGLITETravel, CHECKBOXLITEBAG, PAYMENTCHANNEL, LABELMAPPING, HIDEINREVIEWSCREENFIELDS, CHECKBOXLITEPERSONAL, FNOL_COUNTRY, PAYMENTTYPEFIELDS, MTACOUNTRYLIST, countriesWithNoEmployeeIdField } from '../../../config/fnol-constants';
import { Utils } from 'axis-ui-generator';
import { AxisInputNumberPipe } from 'axis-components';
import { CacheService } from 'src/app/shared/services/cache.service';
import { FnolService } from '../../../services/fnol.service';
import { ClaimTypeClientService } from './claim-type-payload/claim-type-client.service';
import { AppConfig } from 'src/app/shared/config';


@Injectable({
  providedIn: 'root'
})
export class CdpLiteModelService {
  momentDateFormat = 'DD-MM-YYYY';
  personalAccident = [];
  permanantdiablity;
  leavebenifit;
  otherClaimShow;
  accidentalDeatBoolean;
  foundmedical
  policyDetails;
  phoneCodeList;
  insuredDetails = null;
  step2 = 'fnol-claimtype-details';
  step1 = 'fnol-claimant-info';
  country;
  personalDetails = []
  hsotDrInfo = []
  data
  uiStructure: any;
  uiData: any;
  mySettings51: any = {
    view_roundoff: false,
    thousands_separator: ",",
    decimal_separator: ".",
    fraction_size: "2",
    reg_exp: "^\d{1,3}(,\d{3})*(\.\d{2})?$",
    decimal: "",
    restrict: false
  };
  constructor(
    private config: Configuration,
    private dataStoreService: DataStoreService,
    private fnolModelService: FnolModelService,
    public axisPipe: AxisInputNumberPipe,
    private fnolService: FnolService,
    public cacheService: CacheService,
    private claimType: ClaimTypeClientService
  ) {
    this.fnolService.landingSelectedCountry.subscribe(selectedCountry => {
      if (selectedCountry.code) {
        const country = selectedCountry.code.toLowerCase();
        this.country = selectedCountry.code.toLowerCase();
        if (AppConfig.countryConfig[country]["customDateFormat"]) {
          this.momentDateFormat = AppConfig.countryConfig[country]["customDateFormat"].split('/').join("-");
        }
      }
    });

  }

  setPolicyHolderDetails(details: any) {
    this.insuredDetails = {
      policyNo: details["policyNumber"],
      firstName: details["firstName"] || details["policyFirstName"],
      lastName: details["lastName"] || details["policyLastName"],
      dob: details["dateOfBirth"] || details["policyDateOfBirth"],
      nric: details["nricFin"] || details["policyNricFin"],
    };
  }

  getPrivacyPolicySectionInfo() {
    return [
      {
        name: "Privacy Policy:",
        value: "Yes",
      },
      {
        name: "Terms of Use:",
        value: "Yes",
      },
      {
        name: "By continuing with this form, I acknowledge and agree with both Privacy Policy and Terms of Use:",
        value: "Yes",
      },
    ];
  }



  convertDateGMT(datePassed, dateFormat: string, zeroCheck?): string {
    const dateFormatted = moment(datePassed).format(dateFormat);
    if (zeroCheck && zeroCheck === 'zeroTime') {
      return dateFormatted + 'T000000.000 GMT';
    } else { return dateFormatted + 'T050000.000 GMT'; }
  }

  getLossDate() {
    if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Personal Accident') {
      const lossDate = this.convertDateGMT(
        this.dataStoreService.get(this.step2).uiData["accidentDate"],
        "YYYYMMDD"
      );
      return lossDate;
    }
    else if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Travel') {
      const lossDate = this.convertDateGMT(
        this.dataStoreService.get(this.step2).uiData["dateSymptom"],
        "YYYYMMDD"
      );
      return lossDate;
    }

    else if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Other') {
      const lossDate = this.convertDateGMT(
        this.dataStoreService.get(this.step2).uiData["otherDate"],
        "YYYYMMDD"
      );
      return lossDate;
    }
  }

  getLossDocDate() {
    if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Personal Accident') {
      return this.dataStoreService.get(this.step2).uiData["accidentDate"]
    }
    else if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Travel') {
      return this.dataStoreService.get(this.step2).uiData["dateSymptom"]
    }

    else if (this.dataStoreService.get(this.step2).uiData["claimBenefits"] === 'Other') {
      const currentDate = new Date().toString()
      return currentDate
    }
  }

  getDetails(requestName: string) {
    if (requestName === "policyNo") {
      if (this.policyDetails?.response?.policyDetails?.externalReference) {
        return this.policyDetails.response.policyDetails.externalReference;
      }
      else {
        return 'NOPOLICY';
      }
    }
  }

  getFnolRequestBody(
    type: string = "",
    policyDetailsData: any = {},
    phoneCodeListData: any = []
  ) {
    this.policyDetails = policyDetailsData;
    this.phoneCodeList = phoneCodeListData;
    const translations = this.cacheService.getTranslation();

    if (translations) {
      cdpLite.applicationContext.language = translations["en"];
      cdpLite.Icorr.iCorrespondence.requestHeader.language = translations["en"];
      cdpLite.Icorr.iCorrespondence.ApplicationContext.language = translations["en"];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[0].title = translations["Claimant Information"];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[1].title = translations["Claim Details"];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[2].title = translations["Payment Details"];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[3].title = translations["Upload Supporting Documents"];
    }

    cdpLite["applicationContext"]["userId"] =
      this.config.userEmailID;
    cdpLite["applicationContext"]["productTypeCd"] =
      (MTACOUNTRYLIST.includes(this.cacheService.getCountry().toUpperCase()) && this.cacheService.getMTA()) ? "MN" : "";
    cdpLite["claimsDetails"]["userId"] = this.config.userEmailID;
    cdpLite["claimsDetails"]["claimNumber"] =
      this.fnolModelService.getClaimNumber();
    cdpLite["claimsDetails"]["dateofIncident"] =
      this.getLossDate();
    cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.lossDate = this.getLossDate();
    cdpLite.applicationContext.countryCode = this.cacheService.getCountry().toUpperCase();
    cdpLite.Icorr.iCorrespondence.requestHeader.countryCode = this.cacheService.getCountry().toUpperCase();
    cdpLite.Icorr.iCorrespondence.ApplicationContext.country = this.cacheService.getCountry().toUpperCase();
    cdpLite.Icorr.iCorrespondence.correspondenceItem.distributionGenerationData.country = this.cacheService.getCountry().toUpperCase();
    cdpLite.Icorr.iCorrespondence.requestHeader.requestMessageID = this.fnolModelService.getClaimNumber();
    cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.claimID = this.fnolModelService.getClaimNumber()

    if (
      (type === "setFnol")
    ) {
      return cdpLite;
    }
    const finalValue = this.prepDataForPDF(this.step1);
    if (URL_PARAMETERS.COUNTRY.toLowerCase() ===
      FNOL_COUNTRY.LITE.countryCode) {
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[0].attribute = finalValue
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[1].attribute = this.claimType.callService();
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[2].attribute = this.getPaymentData('fnol-payment-details');
      cdpLite.Icorr.iCorrespondence.correspondenceItem.pdfGenerationData.claimDetails.cdpDetails.info[3].attribute = this.getUploadDetails('fnol-upload-docs');
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.claimantEmail = this.dataStoreService.get("fnol-claimant-info").uiData['email'];
      cdpLite.applicationContext.claimTypeCd = this.dataStoreService.get(this.step2).uiData["claimBenefits"];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.mobile = this.dataStoreService.get("fnol-claimant-info").uiData['contactNumber']['phoneCode'].hasOwnProperty('label') ? this.dataStoreService.get("fnol-claimant-info").uiData['contactNumber']['phoneCode']['label'] + "-" + this.dataStoreService.get("fnol-claimant-info").uiData['contactNumber']['phoneNumber'] : this.dataStoreService.get("fnol-claimant-info").uiData['contactNumber']['phoneCode'] + "-" + this.dataStoreService.get("fnol-claimant-info").uiData['contactNumber']['phoneNumber'];
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.reportedByFirstName = this.dataStoreService.getInsuredName('firstName');
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.reportedByLastName = this.dataStoreService.getInsuredName('lastName');
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.insuredName = this.dataStoreService.getInsuredName('fullName');;
      cdpLite.Icorr.iCorrespondence.correspondenceItem.correspondenceGenerationData.policyNumber = this.dataStoreService.get("fnol-claimant-info").uiData['policyNumber'] ? this.dataStoreService.get("fnol-claimant-info").uiData['policyNumber'] : "NOPOLICY";
    }
    return cdpLite;
  }

  decimalConverter(num: string, locale: string): string {
    const convert2Num: number = parseFloat(num);
    const decimalNum = convert2Num.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (decimalNum.substring(decimalNum.length - 3)[0] === ',') {
      const decimalNumber = decimalNum.replace(decimalNum.substring(decimalNum.length - 3)[0], '.');
      return decimalNumber;
    } else {
      return decimalNum;
    }
  }

  // Generated by AIG Copilot - start
  formatPhoneNumber(phoneData: any): string {
    if (phoneData && typeof phoneData === 'object') {
      if (phoneData.phoneCode && phoneData.phoneNumber) {
        const phoneCode = phoneData.phoneCode.hasOwnProperty('label') ?
          phoneData.phoneCode.label : phoneData.phoneCode;
        return `${phoneCode}-${phoneData.phoneNumber}`;
      }
    }
    return phoneData || '';
  }
  // Generated by AIG Copilot - end

  getData(name, type, stepName) {
    let resultData
    this.uiStructure = this.dataStoreService.get(stepName).uiStructure;
    this.uiData = this.dataStoreService.get(stepName).uiData;
    const translations = this.cacheService.getTranslation()
    try {
      resultData = Utils.getFieldFromStructure(this.uiStructure, name);
    }
    catch (error) {
      resultData = '';
      return resultData;
    }

    // Generated by AIG Copilot - start
    // Access phoneFormatting property if available
    if (resultData && resultData.hasOwnProperty('phoneFormatting') && resultData.phoneFormatting === true) {
      // Handle phone formatting when property is true
      if (type === 'phone' || resultData.element === 'PhoneLiteWithFlagComponent') {
        return this.formatPhoneNumber(this.uiData[name]);
      }
    }
    // Generated by AIG Copilot - end
    if (type === "label") {
      if (!resultData) {
        return '';
      }
      if (resultData?.type === "checkbox") {
        return {
          key: resultData?.heading,
          value: resultData?.questionCd,
        }
      }
      if (translations) {
        resultData.label = translations[resultData.label] ? translations[resultData.label] : resultData.label;
      }
      return resultData;
    } else if (type === "rpa") {
      if (resultData?.type === "dropdown") {
        if (resultData.hasOwnProperty('isMultiSearchSelect')) {
          return this.uiData[name].map(i => i.id).join(',')
        } else if (!resultData.hasOwnProperty('isMultiSearchSelect')) {
          return this.uiData[name]?.id
        }
      } else if (resultData?.type === "radio") {
        const selectedOption = resultData.options.find(option => option.value === this.uiData[name]);
        return selectedOption ? selectedOption['label'] : this.uiData[name];
      }
      else if (resultData?.type === "checkbox") {

        return (this.uiData[name] !== null && this.uiData[name] !== '' && this.uiData[name] !== 'No') ? "Yes" : "No"

      }

      else if (resultData?.type === "text" || resultData?.type === "datepicker" || resultData?.type === "timepicker" || resultData?.type === null || resultData?.type === "textarea") {
        return null
      }
    } else {
      if (resultData?.type === "datepicker" && this.uiData[name] !== 'Invalid date' && this.uiData[name] !== null && this.uiData[name] !== '') {
        return (this.uiData[name] !== null && this.uiData[name] !== "") ? moment(new Date(this.uiData[name])).format(this.momentDateFormat) : this.uiData[name];
      } else if (resultData?.type === "timepicker") {
        return (this.uiData[name] !== null && this.uiData[name] !== "") && this.uiData[name]?.length > 5 ? moment(this.uiData[name]).format("hh:mm A") : this.uiData[name];
      } else if (resultData?.type === "checkbox") {
        return (this.uiData[name] !== null && this.uiData[name] !== '' && this.uiData[name] !== 'No') ? $localize`:@@yesNor:Yes` : $localize`:@@noNor:No`
      }
      else if (resultData?.type === "dropdown") {

        if (resultData.hasOwnProperty('isMultiSearchSelect')) {
          return this.uiData[name].map(i => i.name).join(',')
        } else if (!resultData.hasOwnProperty('isMultiSearchSelect')) {
          return this.uiData[name]?.name
        }

      } else if (resultData?.type === "radio") {
        const selectedOption = resultData.options.find(option => option.value === this.uiData[name]);
        return selectedOption ? selectedOption['label'] : this.uiData[name];
      }
      else {
        return this.uiData[name]
      }
    }
  }

  checkCustom(field, index, step) {
    if (this.getData(field + index, "label", step)['type'] === "custom" &&
      this.getData(field + index, "label", step)['element'] === "CurrencyDropdownComponent"
    ) {
      return this.getData(field + index, "", step)['phoneNumber'] ?
        this.getData(field + index, "", step)['phoneCode'].hasOwnProperty('label') ?
          this.getData(field + index, "", step)['phoneCode']['label'] + " " + this.axisPipe.transform(this.getData(field + index, "", step)['phoneNumber'].toString(), this.mySettings51) :
          this.getData(field + index, "", step)['phoneCode'] + " " + this.axisPipe.transform(this.getData(field + index, "", step)['phoneNumber'].toString(), this.mySettings51)
        : null
    }
    else {
      return this.getData(field + index, "", step)
    }
  }

  prepDataForPDF(step) {
    const personalInfo = ["heading", "completeClaim", "policyNumber", "groupName", "insuredFirstName", "insuredLastName", "dob", "currentAge"];
    if (!countriesWithNoEmployeeIdField.includes(this.country)) {
      personalInfo.splice(4, 0, "empId")

    }
    if (AppConfig.countryConfig[this.cacheService.getCountry().toLowerCase()]["claimantPage.fields.name.insuredOccupationMandatory"]) {
      personalInfo.push("insuredOccupation")
    }
    const personalDetailsInfo = [];
    personalInfo.forEach(res => {

      if (res === "heading") {
        personalDetailsInfo.push(
          {
            name: $localize`:@@Personal Information:Personal Information`,
            value: 'heading'
          });
      } else {
        const value = this.getData(res, "", step);
        // if (value) {
        personalDetailsInfo.push(
          {
            name: this.getData(res, "label", step)['label'],
            value
          });
        // }
      }
    });

    const contactInfo = {
      insurer: ["heading", "email", "contactNumber", "personalCountry", "myAddressLookup", "levelUnitNumber", "postalCode"],
      agent: ["heading", "firstName", "lastName", "email", "contactNumber",],
      other: ["heading", "insuredRelationship", "firstName", "lastName", "email", "contactNumber",]
    }

    const heading = {
      insurer: $localize`:@@Insured Contact Information:Insured Contact Information`,
      agent: $localize`:@@Agent or Broker Contact Information:Agent or Broker Contact Information`,
      other: $localize`:@@Other Contact Information:Other Contact Information`
    }

    contactInfo[this.dataStoreService.get(this.step1)['uiData']['completeClaim']['value']].forEach(res => {
      if (res === "heading") {
        personalDetailsInfo.push(
          {
            name: heading[this.dataStoreService.get(this.step1)['uiData']['completeClaim']['value']],
            value: 'heading'
          });
      } else {
        if (res === 'contactNumber' && this.uiData["contactNumber"] !== null) {
          personalDetailsInfo.push(
            {
              name: $localize`:@@Phone Number:Phone Number`,
              value: this.getData("contactNumber", "", step)['phoneCode'].hasOwnProperty('label') ? this.getData("contactNumber", "", step)['phoneCode']['label'] + "-" + this.getData("contactNumber", "", step)['phoneNumber'] : this.getData("contactNumber", "", step)['phoneCode'] + "-" + this.getData("contactNumber", "", step)['phoneNumber']
            });
        } else if (res === "personalCountry" && this.getData(res, "label", step)['type'] === "dropdown") {
          personalDetailsInfo.push({
            name: this.getData('personalCountry', "label", step)['label'],
            value: this.dataStoreService.get('fnol-claimant-info').uiData['personalCountry'].name
          });
        } else if (res === "myAddressLookup") {
          personalDetailsInfo.push(
            {
              name: this.getData(res, "label", step)['label'],
              value: this.dataStoreService.checkAutoComplete(this.getData(res + "val", "", step) ? this.getData(res + "val", "", step) : this.getData(res, "", step).formatted_address ? this.getData(res, "", step).formatted_address : this.getData(res, "", step))
            }
          );
        }
        else if (res === 'levelUnitNumber' && this.uiData['levelUnitNumber'] !== "") {
          personalDetailsInfo.push(
            {
              name: this.getData(res, "label", step)['label'],
              value: this.getData(res, "", step)
            })
        } else {
          // if (res !== 'levelUnitNumber' && this.uiData[res]?.trim() !== "") {
          personalDetailsInfo.push(
            {
              name: this.getData(res, "label", step)['label'],
              value: this.getData(res, "", step)
            });
          // }
        }
      }
    });
    return personalDetailsInfo
  }

  getClaimType(step) {
    const claimType = ["claimBenefits"]
    const claimTypeInfo = []
    claimType.forEach(fieldName => {
      claimTypeInfo.push(
        {
          name: this.getData(fieldName, "label", step)['label'],
          value: this.getData(fieldName, "", step)
        });
    })
    return claimTypeInfo;
  }



  getPaymentData(step) {
    const paymentObj = [];
    let paymentData = this.dataStoreService.get('fnol-payment-details').uiData;
    const translations = this.cacheService.getTranslation();
    const processedFields = new Set();

    if (this.dataStoreService.get('fnol-payment-details-common')?.uiStructure?.paymentFields) {
      const paymentUIStructure = this.dataStoreService.get('fnol-payment-details-common').uiStructure;
      paymentData = this.cleanupBankSantanderData(paymentData);

      // Generated by AIG Copilot - start
      // Initialize resultObject with proper handling for both paymentType and paymentDetailType
      const resultObject: any = {};

      // Helper function to extract value from object (for dropdown/radio fields)
      const extractObjectValue = (fieldValue: any, fieldKey: string) => {
        if (typeof fieldValue === 'object' && fieldValue !== null) {
          if (PAYMENTTYPEFIELDS.contactNumberFieldType.indexOf(fieldKey) > -1) {
            return fieldValue;
          } else if (PAYMENTTYPEFIELDS.radioType.indexOf(fieldKey) > -1) {
            return fieldValue;
          } else if (PAYMENTTYPEFIELDS.dropdownType.indexOf(fieldKey) > -1) {
            return fieldValue;
          } else {
            return fieldValue.name || fieldValue.value || fieldValue;
          }
        }
        return fieldValue;
      };

      // Always include paymentType if it exists
      if (paymentData?.["paymentType"]) {
        resultObject.paymentType = extractObjectValue(paymentData["paymentType"], "paymentType");
      }

      // Check for Version 2 structure (with paymentDetailType)
      if (paymentUIStructure?.paymentFields?.paymentDetailType) {
        // Always include paymentDetailType in Version 2
        if (paymentData?.["paymentDetailType"]) {
          resultObject.paymentDetailType = extractObjectValue(paymentData["paymentDetailType"], "paymentDetailType");
        }

        let fieldsToPopulate = {};

        // If paymentDetailType value is "Yes" (case-insensitive), include paymentType and corresponding fields
        const paymentDetailValue = (paymentData?.paymentDetailType?.value || paymentData?.paymentDetailType || '').toString().toLowerCase();
        if (paymentDetailValue === "yes") {
          // Add paymentType field from paymentDetailType level
          if (paymentUIStructure.paymentFields.paymentDetailType.paymentType) {
            fieldsToPopulate["paymentType"] = true;
          }

          // Add payment type specific fields if paymentType is selected
          if (paymentData?.paymentType) {
            const paymentTypeKey = paymentData.paymentType.value || paymentData.paymentType;
            const paymentTypeFields = paymentUIStructure.paymentFields.paymentDetailType[paymentTypeKey] || {};
            fieldsToPopulate = { ...fieldsToPopulate, ...paymentTypeFields };
          }
        }
        // If paymentDetailType is "No", fieldsToPopulate remains empty (only paymentDetailType will be included)

        // Process fields to populate
        Object.keys(fieldsToPopulate).forEach(key => {
          const hasValue = paymentData[key] && paymentData[key] !== '';
          if (hasValue || fieldsToPopulate[key] === true) {
            resultObject[key] = extractObjectValue(paymentData[key], key);
          }
        });

      } else {
        // Version 1 structure - original logic
        const paymentTypeKey = paymentData?.["paymentType"]?.["value"] || paymentData?.["paymentType"];
        const fieldsToPopulate = paymentUIStructure.paymentFields?.[paymentTypeKey] || {};

        Object.keys(fieldsToPopulate).forEach(key => {
          const hasValue = paymentData[key] && paymentData[key] !== '';
          if (hasValue || fieldsToPopulate[key] === true) {
            resultObject[key] = extractObjectValue(paymentData[key], key);
          }
        });
      }

      paymentData = resultObject;
      // Generated by AIG Copilot - end
    }

    if (this.country !== "hk") {
      // Show payment details availability first if field exists
      if (paymentData?.paymentDetailType) {

        paymentObj.push({
          name: $localize`:@@payment.detailsAvailable:Do you have payment details available?`,
          value: translations?.[paymentData['paymentDetailType'].value] ? translations[paymentData['paymentDetailType'].value] : paymentData['paymentDetailType'].value
        });
        processedFields.add('paymentDetailType');
        if (paymentData?.paymentDetailType.value === "No" || paymentData?.paymentDetailType.value === "Non") {
          return paymentObj
        }
      }

      if (paymentData?.paymentType) {
        paymentObj.push({
          name: $localize`:@@payment.paymentChannel:Payment Channel`,
          value: translations?.[LABELMAPPING[this.country][paymentData['paymentType'].value]] ? translations[LABELMAPPING[this.country][paymentData['paymentType'].value]] : paymentData['paymentType'].value
        });
        processedFields.add('paymentType');
      } else {
        if (PAYMENTCHANNEL[this.country]) {
          paymentObj.push({
            name: $localize`:@@payment.paymentChannel:Payment Channel`,
            value: PAYMENTCHANNEL[this.country]
          });
        }
      }

      if (paymentData?.claimExpenses) {
        paymentObj.push({
          name: "Are you claiming or intend to claim the expenses incurred from other insurance companies or organizations?",
          value: paymentData['claimExpenses'].value
        });
        processedFields.add('claimExpenses');
      }

      Object.keys(paymentData).forEach(item => {
        if (LABELMAPPING[this.country][item] && !processedFields.has(item)) {
          let fieldName = LABELMAPPING[this.country][item];

          // Use i18n translations if available
          if (translations?.[fieldName]) {
            fieldName = translations[fieldName];
          }

          paymentObj.push({
            name: fieldName,
            hideInReview: HIDEINREVIEWSCREENFIELDS.indexOf(item) > -1 ? true : false,
            value: this.typeOfField(item, paymentData)
          });
        }
      });
    } else {
      Object.keys(paymentData).forEach((item, index) => {
        if (index !== 1) {
          if (LABELMAPPING[this.country][item]) {
            paymentObj.push({
              name: LABELMAPPING[this.country][item],
              hideInReview: HIDEINREVIEWSCREENFIELDS.indexOf(item) > -1 ? true : false,
              value: item === "ownerStructure" || item === "claimExpenses" ? paymentData[item]['value'] : item === 'claimInsured' ? paymentData[item] + "%" : paymentData[item]
            });
          }
        } else {
          paymentObj.push({
            name: "Are you claiming or intend to claim the expenses incurred from other insurance companies or organizations?",
            value: paymentData['claimExpenses'].value
          });
          paymentObj.push({
            name: $localize`:@@payment.paymentChannel:Payment Channel`,
            value: paymentData['paymentType'].value
          });
        }
      });
    }

    return paymentObj;
  }
  typeOfField(item, paymentData) {
    //  item == "ownerStructure" || item == "claimExpenses" ? paymentData[item]['value'] : item == 'claimInsured' ? paymentData[item] + "%" : paymentData[item]
    if (PAYMENTTYPEFIELDS.radioType.indexOf(item) > -1) {
      return paymentData[item]['value']
    } else if (PAYMENTTYPEFIELDS.percentageType.indexOf(item) > -1) {
      return paymentData[item] + "%";
    } else if (PAYMENTTYPEFIELDS.dropdownType.indexOf(item) > -1) {
      // Handle payment currency fields specifically
      if (item === 'paymentCurrencyIBT' || item === 'paymentCurrencyIBAN') {
        if (paymentData[item] && typeof paymentData[item] === 'object') {
          return paymentData[item]['label'] || paymentData[item]['name'] || paymentData[item]['value'] || '';
        }
        return paymentData[item] || '';
      }
      return paymentData[item]?paymentData[item]['name']: '';
    } else if (PAYMENTTYPEFIELDS.contactNumberFieldType.indexOf(item) > -1) {
      // Generated by AIG Copilot - start
      // Check if phoneFormatting property is available and handle formatting
      const fieldStructure = this.getFieldStructureFromPaymentData(item);
      if (fieldStructure && fieldStructure.phoneFormatting === true) {
        return this.formatPhoneNumber(paymentData[item]);
      }
      // Generated by AIG Copilot - end
      return paymentData[item] ? paymentData[item + 'Code']['label'] + '-' + paymentData[item] : ""
    } else {
      return this.dataStoreService.checkAutoComplete(paymentData[item]);
    }
  }

  getUploadDetails(step) {
    const obj = []
    if (this.dataStoreService.get(step).uiData.customFileUpload) {
      const fileList = this.dataStoreService.get(step).uiData.customFileUpload.uploads;
      fileList.forEach((element, i) => {
        obj.push(
          {
            name: $localize`:@@documents.upload:Upload` + (i + 1) + ":",
            value: element.name
          }
        );
      });
      return obj;
    } else {
      return obj;
    }
  }

  // Generated by AIG Copilot - start
  getFieldStructureFromPaymentData(fieldName: string): any {
    try {
      const paymentStructure = this.dataStoreService.get('fnol-payment-details-common').uiStructure;
      return Utils.getFieldFromStructure(paymentStructure, fieldName);
    } catch (error) {
      return null;
    }
  }

  cleanupBankSantanderData(paymentData: any): any {
    // Clean up Bank Santander specific fields based on current selection
    if (paymentData && paymentData.bankSantander) {
      const selectedOption = paymentData.bankSantander.value || paymentData.bankSantander;
      const cleanedData = { ...paymentData };

      cleanedData.bankSantander = selectedOption; // Keep the selected option for Bank Santander

      // Define Bank Santander field mapping
      const bankSantanderFields = {
        'yes': ['clabeInterbancaria_EBT', 'confirmCLABEInterbancaria_EBT'], // If Option1 selected, clear fieldA and fieldB
        'no': ['accountNumber_EBT', 'confirmAccountNumber_EBT'], // If Option2 selected, clear fieldC and fieldD
      };

      if (bankSantanderFields[selectedOption]) {
        bankSantanderFields[selectedOption].forEach(field => {
          if (cleanedData[field]) {
            delete cleanedData[field];
          }
        });
      }

      const translations = this.cacheService.getTranslation();
      if (translations) {
        cleanedData.bankSantander = translations[cleanedData.bankSantander] ? translations[cleanedData.bankSantander] : cleanedData.bankSantander;
      }

      return cleanedData;
    }
    return paymentData;
  }
  // Generated by AIG Copilot - end



  getDammageDelayDetails() {
    const nonBagNoEMp = ["nameClinic", "dateOfAdmission", "timeAdmission", "timeDischarge"]
    const travelArr = this.buildDetails({ mainUIFieldName: "addTreatment", fieldNames: nonBagNoEMp, conditionalFieldName: "admittedHospital" });
    return travelArr
  }

  buildDetails({
    mainUIFieldName,
    fieldNames,
    conditionalFieldName,
  }: {
    mainUIFieldName: string;
    fieldNames: string[];
    conditionalFieldName?: string
  }) {

    // array to return
    let formattedArray = [];
    // uiStructure fields

    const container = Utils.getFieldFromStructure(
      this.dataStoreService.get(this.step2).uiStructure,
      mainUIFieldName
    ).fields;
    const uiData = this.dataStoreService.get(this.step2).uiData;
    // loop over fields
    for (let i = 0; i < container.length; i++) {
      const matches = container[i].name.match(/(\d+)/);
      const digit = matches?.[0];

      // a main if condition that if "Yes", then do the rest
      if (conditionalFieldName) {
        if (uiData[conditionalFieldName] === "Yes") {
          // array of nested fields to look for
          // loop over nested fields
          formattedArray = this.pushFieldNames({ fieldNames, formattedArray, index: digit ? digit : "" });
        }
      } else {
        formattedArray = this.pushFieldNames({ fieldNames, formattedArray, index: digit ? digit : "" });
      }
    }
    // the main data
    // return array
    return formattedArray;
  }

  pushFieldNames({ fieldNames, formattedArray, index }: { fieldNames: string[]; formattedArray: any[]; index?: string }): { name: string; data: any }[] {
    // array of nested fields to look for
    // loop over nested fields
    fieldNames.forEach((name) => {
      // check for type "checkbox" is unnecessary
      // do one check to make sure data is there
      const data = this.getData(name + index, "", this.step2);
      if (data) {
        // then push to array
        formattedArray.push({
          name: this.getData(name + index, "label", this.step2)["label"],
          value: data,
        });
      }
    });
    return formattedArray;
  }


}
